import { LitElement, html, css } from 'lit'

class RadioGroup extends LitElement {

  constructor() {
    super()

  }

  firstUpdated() {

  }

  static properties = {

  }

  render() {
    return html` <slot></slot> `
  }
}

customElements.define('radio-group', RadioGroup)